import React, { ReactNode } from 'react';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { styles } from './BaseCard.css';

export type BaseCardProps = {
  cover?: ReactNode;
  footer?: ReactNode;
  isContained?: boolean;
  children?: ReactNode | Array<ReactNode>;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void | Promise<void>;
  href?: string;
  target?: string;
  style?: React.CSSProperties;
};

export const BaseCard = ({
  cover,
  footer,
  isContained = true,
  children,
  className,
  onClick,
  href,
  target,
  style,
}: BaseCardProps) => {
  const hasFooter = Boolean(footer);
  const isCoverOnly = Boolean(cover) && !children && !footer;

  return (
    <a
      className={classNames([styles.container({ isContained }), className])}
      style={style}
      onClick={onClick}
      href={href}
      target={target}
    >
      {cover ? <div className={styles.cover({ isCoverOnly })}>{cover}</div> : null}
      {children ? <div className={styles.content({ isContained, hasFooter })}>{children}</div> : null}
      {footer ? <div className={styles.footer({ isContained })}>{footer}</div> : null}
    </a>
  );
};
